module.exports = __webpack_public_path__ + "static/media/LoginBackgroundMobile.abcbdfc2.jpg";